import { Button, Row, Tooltip, Typography } from 'antd';
import { Footer } from 'antd/es/layout/layout';
import { useTranslation } from 'react-i18next';
import ExplorerConsulting from '../Assets/Images/ExplorerConsulting.png';
import { FaYoutube } from 'react-icons/fa';
import { FiYoutube } from 'react-icons/fi';
import { useTheme } from '../context/ThemeContext';

interface AppFooterProps {
  isDark?: boolean;
}

export const AppFooter = ({
  isDark = false,
}: AppFooterProps): React.ReactElement => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  return (
    <Footer
      style={{
        textAlign: 'center',
        padding: '8px 20px',
        background: isDark
          ? '#0000008c'
          : isDarkMode
            ? '#2f2f2f74'
            : '#ececec57',
        borderTop: '1px solid #ffffff33',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
      }}
    >
      <Row align="middle" justify="center">
        <Typography.Text
          style={{
            color: isDark ? '#ffffffb3' : isDarkMode ? '#ffffffb3' : '#000000',
            fontFamily: 'Calibri',
            fontSize: '14px',
            marginRight: '10px',
            marginBottom: 0,
          }}
        >
          {t('loginPage.createdBy')}
        </Typography.Text>
        <a
          href="https://explorer-consulting.ro"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <img
            alt="company-logo"
            src={ExplorerConsulting}
            style={{ height: '28px', width: 'auto' }}
          />
        </a>
      </Row>

      {/* YouTube icon */}
      <div
        style={{
          position: 'absolute',
          right: '24px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Tooltip placement="top" title={t('header.help')}>
          <Button
            type="text"
            icon={
              isDark ? (
                <FiYoutube style={{ color: 'white' }} fontSize={30} />
              ) : (
                <FaYoutube fontSize={30} />
              )
            }
            aria-label={t('header.help')}
            onClick={() =>
              window.open(process.env.REACT_APP_DEMOS_URL, '_blank')
            }
            style={{
              cursor: 'pointer',
              border: 'none',
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = '1')}
            onMouseOut={(e) => (e.currentTarget.style.opacity = '0.8')}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                window.open(process.env.REACT_APP_DEMOS_URL, '_blank');
              }
            }}
          />
        </Tooltip>
      </div>
    </Footer>
  );
};
